export const isQogitaUserEmail = (email: string): boolean =>
  new RegExp(/@(test.)?qogita.com/).test(email);
